import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { retrieve } from '../../../../Services/localStorageService';
import { clearAuth } from '../../Config/Auth';
import { hasPermission } from '../Services/permission';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children, requiredPermission = null }) => {
  const location = useLocation();
  const token = retrieve('accessToken');
  const expiry = retrieve('accessTokenExpiry');

  let isValid = false;

  if (token && expiry) {
    try {
      const notExpired = Date.now() < Number(expiry);

      if (notExpired) {
        const decoded = jwtDecode(token);

        isValid = decoded?.module === 'HS';
      }
    } catch (error) {
      isValid = false;
    }
  }

  if (!isValid) {
    clearAuth();
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  const permissionCheck = hasPermission(requiredPermission);

  if (requiredPermission && !permissionCheck) {
    clearAuth();
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return children;
};

export default ProtectedRoute;
